import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {TranslationService} from '@spartacus/core';
import {
  Configurator,
  ConfiguratorAttributeCompositionContext,
  ConfiguratorAttributeQuantityService,
  ConfiguratorAttributeRadioButtonComponent,
  ConfiguratorCommonsService,
  ConfiguratorStorefrontUtilsService,
} from '@spartacus/product-configurator/rulebased';
import {HasPendingChangesService} from '../disable-loading-form/has-pending-changes.service';

@UntilDestroy()
@Component({
  selector: 'dcp-configurator-attribute-radio-button',
  templateUrl: './dcp-configurator-attribute-radio-button.component.html',
  styleUrls: ['./dcp-configurator-attribute-radio-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DcpConfiguratorAttributeRadioButtonComponent
  extends ConfiguratorAttributeRadioButtonComponent
  implements OnInit
{
  toggleValue?: boolean;
  override attributeRadioButtonForm = new UntypedFormControl('');
  hasPendingChanges: boolean = false;

  constructor(
    protected override quantityService: ConfiguratorAttributeQuantityService,
    protected hasPendingChangesService: HasPendingChangesService,
    translationService: TranslationService,
    configuratorAttributeCompositionContext: ConfiguratorAttributeCompositionContext,
    configuratorCommonsService: ConfiguratorCommonsService,
    configuratorStorefrontUtilsService: ConfiguratorStorefrontUtilsService,
    private cdr: ChangeDetectorRef,
  ) {
    super(
      quantityService,
      translationService,
      configuratorAttributeCompositionContext,
      configuratorCommonsService,
      configuratorStorefrontUtilsService,
    );
  }

  override ngOnInit(): void {
    this.attributeRadioButtonForm.setValue(this.attribute.selectedSingleValue);
    if (this.isToggle(this.attribute)) {
      this.toggleValue = this.getInitialToggleState(this.attribute);
    }
    this.hasPendingChangesService
      .hasPendingChanges()
      .pipe(untilDestroyed(this))
      .subscribe((hasPendingChanges) => (this.hasPendingChanges = hasPendingChanges));
    this.cdr.markForCheck();
  }

  getInitialToggleState(attribute: Configurator.Attribute): boolean {
    return attribute.values?.find((value) => value.selected)?.valueCode === 'TRUE';
  }

  isToggle(attribute: Configurator.Attribute): boolean {
    const isEitherTrueOrFalse = (currentValue: any) =>
      currentValue.valueCode === 'TRUE' || currentValue.valueCode === 'FALSE';
    return attribute.values?.every(isEitherTrueOrFalse) ?? false;
  }

  onToggle(event: Event): void {
    const customEvent = event as CustomEvent;
    const value = (customEvent.currentTarget as any).attributes.checked;
    if (this.toggleValue === value) {
      return;
    }
    this.configuratorCommonsService.updateConfiguration(
      this.ownerKey,
      {
        ...this.attribute,
        selectedSingleValue: value ? 'TRUE' : 'FALSE',
      },
      Configurator.UpdateType.ATTRIBUTE,
    );
  }

  onChange(value: string): void {
    if (!this.hasPendingChanges && this.attributeRadioButtonForm.value !== value) {
      super.onSelect(value);
    }
  }

  getToggleTooltipText() {
    return this.attribute.values?.find((value) => value.selected)?.description;
  }
}
